import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IRootProps {
  widthValue?: string;
  opacityValue?: string;
  flex?: Boolean;
  selected?: boolean;
  transparent?: boolean;
}

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px;
  box-sizing: border-box;
  overflow: hidden;
`;

export const SimilarTitle = styled.div`
  font-family: Roboto;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #8d8d8d;
  padding:15px 0 0 15px;
`;

export const HelpText = styled.div`
  font-family: Roboto;
  font-size: 13px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  padding: 0 0 5px 15px;
  letter-spacing: normal;
  text-align: left;
  color: #204078;  
  line-height: 1.54;
  letter-spacing: normal;
  text-align: left;
  
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;


`;


export const ShapesContainer = styled.div`
  display:flex;
  flex-wrap:wrap;
`;

export const ShapeContainer = styled.div`
   padding: 7px;   
`;

export const ShapeVerticalContainer = styled.div`
   padding: 14px;   
`;

export const ImgShape = styled.img`
   max-width: 100%;
   max-height: 100%;
   object-fit: contain;
`;



export const DragShapeContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  background-color:transparent;  
  transform: translate(0, 0);
  padding:2px;
  cursor:pointer;
`;



export const DesignsContainer = styled.div`
  box-sizing: border-box;
  margin-top:10px;
  width: 100%;
  position: relative;
  height: calc(100vh - 250px);
  overflow-y: auto;
  overflow-x: hidden;
  padding-left:15px;
 
`

export const EmptyContainer = styled.div`
  box-sizing: border-box;
  margin: 10px 0 0 0;
  width: 100%;
  position: relative;
  height:350px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;  
  font-family: Roboto;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  text-align: center;
  color: #8d8d8d;
  padding:15px;

`

export const DesignsWrap = styled.div`
  .group-list {
    padding: 4px;
    display: ${(props: IRootProps) => props.flex ? 'grid' : 'unset'};
    grid-template-columns: ${(props: IRootProps) => props.flex ? 'repeat(auto-fill, 230px)' : 'unset'};
    justify-content: ${(props: IRootProps) => props.flex ? 'space-between' : 'unset'};
  }
`

export const PreviewContainer = styled.div`
  flex: 1;
  height: 130px;
  width: 90%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction:column;
  border-radius: 5px;
  background-color: ${C.WHITE};    
  border: ${(props: IRootProps) => (props.selected ? `1px solid ${C.DARK_ORANGE}` : `1px solid white`)};
  cursor: pointer;
  
  &:hover {
    transform: scale(1.02);
    border: ${(props: IRootProps) => (props.selected ? `1px solid ${C.DARK_ORANGE}` : `1px solid rgba(32, 64, 120, 0.3)`)};
    box-shadow: 2px 2px 10px 2px rgba(0, 0, 0, 0.05);    
  }
  
`;


export const ImgContainer = styled.img`
  height: 100px;
  display: flex;
  
  width: 85%;
  text-align: center;
  object-fit: contain;
  box-sizing: border-box;
  ${(props: IRootProps) => (props.transparent ? `{
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUAQMAAAC3R49OAAAABlBMVEX////09PQtDxrOAAAAE0lEQVQI12P4f4CBKMxg/4EYDAAFkR1NiYvv7QAAAABJRU5ErkJggg==');
    background-image: linear-gradient(45deg, $color 25%, transparent 25%), linear-gradient(-45deg, $color 25%, transparent 25%), linear-gradient(45deg, transparent 75%, $color 75%), linear-gradient(-45deg, transparent 75%, $color 75%);
    background-size: 20px 20px;
    background-position: 0 0, 0 10px, 10px -10px, -10px 0px;

    

  }` : ``)};
    
`;

export const ImgTitle = styled.div`
  display:flex;
  font-family: Roboto;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  margin-top:4px;
  color: #8891a0;
  `;


  export const LoaderContainer = styled.div`
`


export const SlidersContainer = styled.div`
  box-sizing: border-box;
  margin-top:10px;  
  padding-left:8px;
  width: 100%;  
  height: calc(100vh - 250px);
  overflow-y: auto;
  overflow-x: hidden;
`

export const SwipeableContainer = styled.div`

  width: 225px;
`


export const ItemContainer = styled.div`
  flex: 1;
  height: 90px;
  width: 90px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction:column;
  border-radius: 5px;
  background-color: ${C.WHITE};    
  border: ${(props: IRootProps) => (props.selected ? `1px solid ${C.DARK_ORANGE}` : `1px solid white`)};
  cursor: pointer;
  
  &:hover {
    transform: scale(1.02);
    border: ${(props: IRootProps) => (props.selected ? `1px solid ${C.DARK_ORANGE}` : `1px solid rgba(32, 64, 120, 0.3)`)};
    box-shadow: 2px 2px 10px 2px rgba(0, 0, 0, 0.05);    
  }
  
`;

export const LogoTitleContainer = styled.div`
  display:flex;
  margin-top:10px;

`;

export const LogoTitle = styled.div`
      height: 15px;      
      margin: 11px 0 10px 10px;
      font-family: Roboto;
      font-size: 13px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: left;
      color: #122442;
      display:flex;
      
`;

export const ViewAll = styled.div`
  cursor:pointer;  
  display:flex;
  flex-direction: row;
`;

export const ViewAllText = styled.div`

font-family: Roboto;
font-size: 14px;
font-weight: bold;
font-stretch: normal;
font-style: normal;
line-height: normal;
letter-spacing: normal;
text-align: left;
color: #122442;
margin-top:auto;
margin-bottom:7px;
`;


export const ViewAllContainer = styled.div`
  box-sizing: border-box;
  margin-top:10px;  
  padding-left:8px;
  width: 100%;  
  height: calc(100vh - 250px);  
`
export const LogoContainer = styled.div`
  flex: 1;
  height: 106px;
  width: 106px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction:column;
  border-radius: 5px;
  background-color: ${C.WHITE};    
  border: ${(props: IRootProps) => (props.selected ? `1px solid ${C.DARK_ORANGE}` : `1px solid white`)};
  cursor: pointer;
  
  &:hover {
    transform: scale(1.02);
    border: ${(props: IRootProps) => (props.selected ? `1px solid ${C.DARK_ORANGE}` : `1px solid rgba(32, 64, 120, 0.3)`)};
    box-shadow: 2px 2px 10px 2px rgba(0, 0, 0, 0.05);    
  }
  
`;

export const LogosWrap = styled.div`
  .group-list {
    padding: 5px;
    display: ${(props: IRootProps) => props.flex ? 'grid' : 'unset'};
    grid-template-columns: ${(props: IRootProps) => props.flex ? 'repeat(auto-fill, 110px)' : 'unset'};
    justify-content: ${(props: IRootProps) => props.flex ? 'space-between' : 'unset'};
  }
`

export const LogosContainer = styled.div`
  box-sizing: border-box;
  margin-top:10px;
  width: 100%;
  position: relative;
  height: calc(100vh - 325px);
  overflow-y: auto;
  overflow-x: hidden;
  padding-right:5px;
 
`